// ====================
// SPINNER FOR SKIPPAIR
// ====================

import {Spinner} from 'spin.js';

const SkippairSpinner = (function() {
    var _self;
    function SkippairSpinner(target, top, left) {
        this.target = target;
        _self = new Spinner({
            lines: 13,
            length: 25,
            width: 14,
            radius: 42,
            scale: 0.5,
            corners: 1,
            color: '#0cc',
            opacity: 0.25,
            rotate: 0,
            direction: 1,
            speed: 1,
            trail: 60,
            fps: 30,
            zIndex: 2e9,
            className: 'spinner',
            top: top || '20%',
            left: left || '33%',
            shadow: false,
            hwaccel: true,
            position: 'absolute'
        }).spin(target[0]);
        this.hide();
    };

    SkippairSpinner.prototype.show = function() {
        this.target.css('display', 'inline')
    };

    SkippairSpinner.prototype.hide = function() {
        this.target.css('display', 'none')
    };

    return SkippairSpinner
})()

export default SkippairSpinner


// WEBPACK FOOTER //
// ./search/static/search/js/utils/skippairSpinner.js